import React, { PropTypes } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import PostsList from './PostsList';
import CreatePostModule from './CreatePostModule';

import CurrentRoleStore from '../../stores/CurrentRoleStore';
import CurrentRoleActions from '../../actions/CurrentRoleActions';

import { hashHistory } from 'react-router';
import { Icon } from 'antd';

let POSTS_LIMIT_PER_PAGE = 10;

export default class PostsIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      albumId: parseInt(props.params.albumId),
      albumInfo: null,

      albumPosts: [],
      teacherPosts: [],
      myselfPosts: [],

      userRoleInfo: CurrentRoleStore.getCurrentRole(),

      currentSection: 'album',  // 'album', 'teacher', 'myself'
      sectionHasMore: {album: true, teacher: true, myself: true}
    };
    // bind this
    this.gotoEditAlbumPage = this.gotoEditAlbumPage.bind(this);
    this.loadAlbum = this.loadAlbum.bind(this);
    this.loadPosts = this.loadPosts.bind(this);
    this.onScrollToBottom = this.onScrollToBottom.bind(this);
    this.onSelectSection = this.onSelectSection.bind(this);
    this.onUserRoleChange = this.onUserRoleChange.bind(this);
    this.onLoadNewerPosts = this.onLoadNewerPosts.bind(this);
    this.onDestroyPost = this.onDestroyPost.bind(this);
    this.updatePosts = this.updatePosts.bind(this);
    this._postsListView = this._postsListView.bind(this);
  }

  componentWillMount() {
    this.isLoading = false;
    CurrentRoleStore.addChangeListener(this.onUserRoleChange);

    // get album info
    this.loadAlbum(this.props.params.albumId);

    // callback if userRoleInfo is undefined
    if (!this.state.userRoleInfo) {
      let classId = this.props.location.query.classId;
      let studentId = this.props.location.query.studentId;
      let criteria = classId ? {classId: classId} : {studentId: studentId};
      CurrentRoleActions.findAndSetCurrentUserRole(criteria);
    }
  }

  componentWillUnmount(){
      CurrentRoleStore.removeChangeListener(this.onUserRoleChange);
  }

  componentWillReceiveProps(newProps) {
    if (parseInt(newProps.params.albumId) != this.state.albumId) {
      this.isLoading = false;
      this.setState({
        albumId: parseInt(newProps.params.albumId),
        albumPosts: [],
        teacherPosts: [],
        myselfPosts: [],

        sectionHasMore: {album: true, teacher: true, myself: true}
      });
    }
  }

  // Tools

  updatePosts(post){
    this.state.albumPosts.forEach((albumPost,index) => {
      if(albumPost.id == post.id){
        this.state.albumPosts[index] = post
      }
    });
    this.state.teacherPosts.forEach((albumPost,index) => {
      if(albumPost.id == post.id){
        this.state.teacherPosts[index] = post
      }
    });
    this.state.myselfPosts.forEach((albumPost,index) => {
      if(albumPost.id == post.id){
        this.state.myselfPosts[index] = post
      }
    });

    this.setState({
      albumPosts: this.state.albumPosts,
      teacherPosts: this.state.teacherPosts,
      myselfPosts: this.state.myselfPosts
    });
  }

  gotoEditAlbumPage() {
    hashHistory.push(`albums/${this.state.albumId}/edit?classId=${this.state.albumInfo.class_record_id}`);
  }

  loadAlbum(albumId) {
    DataService.getAlbum(albumId).then((response) => {
      this.setState({
        albumInfo: response
      })
      DataService.getClassById(response.class_record_id).then((classReocord) => {
        this.setState({
          classReocord
        })
      }, (error) => { })
    }, (error) => {})
  }

  // Loading posts with conditions, all logics are depends on @data instead of this.state
  // @actionAfterLoad: ['append', 'insert']
  loadPosts(albumId, data, actionAfterLoad = 'append') {
    if (this.isLoading)
      return;

    this.isLoading = true;
    let postsDataKeyMap = {"undefined": "albumPosts", "teacher": "teacherPosts", "myself": "myselfPosts"};
    let dataKey = data.filter ? postsDataKeyMap[data.filter] : postsDataKeyMap[typeof data.filter];
    let hasMoreKeyMap = {"undefined": "album", "teacher": "teacher", "myself": "myself"};
    let hasMoreKey = data.filter ? hasMoreKeyMap[data.filter] : hasMoreKeyMap[typeof data.filter];
    DataService.getAlbumPosts(albumId, data).then((response) => {
      response.forEach((post)=>{
        post.author_name = SharedTools.addRoleName(post.role, post.author_name);
        post.likes.forEach((like) => {
          like.author_name = SharedTools.addRoleName(like.author_role, like.author_name);
        })
        post.comments.forEach((comment) => {
          comment.author_full_name = SharedTools.addRoleName(comment.author_role, comment.author_full_name);
          comment.reply_to_full_name = SharedTools.addRoleName(comment.reply_to_role, comment.reply_to_full_name)
        })
      })
      this.state[dataKey] = actionAfterLoad === 'append' ? this.state[dataKey].concat(response) : response.concat(this.state[dataKey]);
      if (response.length < POSTS_LIMIT_PER_PAGE)
        this.state.sectionHasMore[hasMoreKey] = false;
      this.setState({
        sectionHasMore: this.state.sectionHasMore
      })
      this.isLoading = false
    }, (response) => {
      // error response: {status: XXX, errorMessage: {errors: [{message: "Class not found", code: 41}]}}
    }).catch((error) => {
      // catch any error above block ('then' block)
    });
  }

  // Events
  onScrollToBottom(page) {
    let requestData = {limit: POSTS_LIMIT_PER_PAGE}
    if (this.state.currentSection != 'album')
      requestData.filter = this.state.currentSection;
    let postCount = this.state[this.state.currentSection + 'Posts'].length;
    if (postCount > 0) {
      requestData.to_id = this.state[this.state.currentSection + 'Posts'][postCount - 1].id;
    }
    if (this.state.userRoleInfo && this.state.userRoleInfo.associatName == "student")
      requestData.student_id = this.state.userRoleInfo.associatObj.id;

    if (this.state.sectionHasMore[this.state.currentSection])
      this.loadPosts(this.state.albumId, requestData);
  }

  onSelectSection(e) {
    let newSelectedSectinoName = e.currentTarget.dataset.sectionname;
    if (newSelectedSectinoName != this.state.currentSection)
      this.setState({
        currentSection: newSelectedSectinoName
      })
  }

  onUserRoleChange() {
    this.setState({
      userRoleInfo: CurrentRoleStore.getCurrentRole()
    });
  }

  onLoadNewerPosts() {
    let requestData = {};
    if (this.state[`${this.state.currentSection}Posts`].length > 0)
      requestData.from_id = this.state[`${this.state.currentSection}Posts`][0].id + 1;
    if (this.state.currentSection != 'album')
      requestData.filter = this.state.currentSection;
    if (this.state.userRoleInfo && this.state.userRoleInfo.associatName == "student")
      requestData.student_id = this.state.userRoleInfo.associatObj.id;

    this.loadPosts(this.state.albumId, requestData, 'insert');
  }

  onDestroyPost(postId) {
    ['albumPosts', 'teacherPosts', 'myselfPosts'].forEach((postListName) => {
      let index = this.state[postListName].findIndex((post) => post.id === postId);
      if (index >= 0)
        this.state[postListName].splice(index, 1);
    });
    this.setState({
      albumPosts: this.state.albumPosts,
      teacherPosts: this.state.teacherPosts,
      myselfPosts: this.state.myselfPosts
    });
  }

  // Views
  _albumInfoView() {
    let style = {};
    if (this.state.albumInfo)
      style.backgroundImage = `url(${this.state.albumInfo.cover})`;
    return (
      <div className="album-info" style={style}>
        <div className="place-holder"></div>
        {this.state.albumInfo && <div className="album-title">{this.state.albumInfo.title}</div>}
        {this.state.albumInfo && <div className="album-description">{this.state.albumInfo.description}</div>}
        {this.state.userRoleInfo && this.state.userRoleInfo.associatName !== "student" && this.state.albumInfo &&
          <div className="edit-btn" onClick={this.gotoEditAlbumPage}><Icon type="edit" /> &nbsp;编辑相册</div>
        }
      </div>
    )
  }

  _sectionsBarView() {
    let sections = [{name: "全部", sectionName: "album"}, {name: "老师", sectionName: "teacher"}, {name: "我的", sectionName: "myself"}];
    return (
      <div className={"sections-bar " + (this.state.currentSection + "-selected")}>
        {sections.map(section =>
          <div className={"tab" + (this.state.currentSection == section.sectionName ? ' selected' : '')}
              key={section.sectionName} data-sectionname={section.sectionName} onClick={this.onSelectSection}>
            {section.name}
          </div>
        )}
      </div>
    )
  }

  _postsListView(postsList) {
    let loaderDom = <div className="scroll-loader">{this.state.sectionHasMore[this.state.currentSection] ? "正在读取新鲜事 ..." : "没有更多新鲜事了"}</div>;
    return (
      <InfiniteScroll
        pageStart={0}
        loadMore={this.onScrollToBottom}
        hasMore={this.state.sectionHasMore[this.state.currentSection]}
        loader={loaderDom}
        useWindow={true}
        key={this.state.currentSection}
      >
        <PostsList posts={postsList} type={'albumPost'} userRoleInfo={this.state.userRoleInfo} onDestroyPost={this.onDestroyPost} updatePosts={this.updatePosts} />

        {!this.state.sectionHasMore[this.state.currentSection] && postsList.length > 0 && <div className="no-more-scroll">没有更多新鲜事了</div>}
        {!this.state.sectionHasMore[this.state.currentSection] && postsList.length <= 0 && <div className="no-posts">相册里还是空空的哟</div>}
      </InfiniteScroll>
    );
  }

  render() {
    return (
      <div className="posts-index-page">
        {this._albumInfoView()}
        {(this.state.classReocord && !this.state.classReocord.is_graduated) ? <CreatePostModule userRoleInfo={this.state.userRoleInfo} albumId={this.state.albumId} successCallBack={this.onLoadNewerPosts} /> : ''}
        {this._sectionsBarView()}
        {this.state.currentSection === 'album' && this._postsListView(this.state.albumPosts)}
        {this.state.currentSection === 'teacher' && this._postsListView(this.state.teacherPosts)}
        {this.state.currentSection === 'myself' && this._postsListView(this.state.myselfPosts)}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/album/PostsIndexPage.jsx